import { jsxs as z, jsx as m } from "react/jsx-runtime";
import { useRef as y, useState as p, useEffect as E, useCallback as k } from "react";
/* empty css                           */
import { DEFAULT_PLAYER_ID as ie } from "../../lib/constants.mjs";
import { generateUniqueId as W } from "../../lib/generateUniqueId.mjs";
import { fetchBrightcoveData as oe, getVideoResourceUrl as ae } from "../../lib/fetchBrightcoveData.mjs";
import { loadBrightcoveScript as ce, isScriptAlreadyLoaded as le } from "../../lib/loadBrightcoveScript.mjs";
import { VideoPoster as de } from "../VideoPoster/VideoPoster.mjs";
import { VideoDescription as ue } from "../VideoDescription/VideoDescription.mjs";
import { useVideoPlayerContext as fe } from "../VideoPlayer/VideoPlayerProvider.mjs";
const Se = ({
  accountId: g,
  policyKey: V,
  playerId: R = ie,
  testId: Y,
  autoplay: D = !1,
  inline: q = !1,
  playlistId: j,
  className: G,
  onReady: A,
  videoId: $,
  deferLoad: O = !0
}) => {
  const I = y(null), b = y(null), h = y(null), [S, H] = p([]), x = y({}), C = y(!1), F = y(!1), [_, J] = p(!O), [X, c] = p("idle"), [Z, d] = p(O), [N, f] = p(!1), [B, w] = p(null), [K, U] = p(!1), [Q, M] = p(!1), v = fe(), T = y(W());
  E(() => {
    C.current || (C.current = !0, oe(
      g,
      V,
      ae($, j)
    ).then((e) => {
      const o = [], r = new Set(
        Object.values(x.current).map((a) => a.id)
      ), l = (a, t) => {
        if (r.has(a.id)) return;
        const s = W(), n = {
          ...a,
          uniquePlayerId: s,
          autoplay: D && t === 0
        };
        x.current[s] = n, o.push(n);
      };
      Array.isArray(e.videos) ? e.videos.forEach((a, t) => l(a, t)) : l(e), H(o), U(!0);
    }).catch(() => {
      c("error"), w("Video unavailable"), d(!0), U(!0);
    }));
  }, [$, j, D, g, V]), E(() => {
    if (!_ || S.length === 0 || F.current) return;
    const e = I.current;
    if (!e) return;
    F.current = !0, c("loading"), Object.keys(x.current).forEach((r) => {
      const l = e.querySelector(`#${r}-text-target`);
      l && l.addEventListener("click", () => {
        const a = e.querySelector(
          `#${r}-vc-video-container`
        ), t = a == null ? void 0 : a.querySelector("video");
        t && (a != null && a.classList.contains("currently-playing")) ? t.pause() : t && t.play();
      });
    });
    const o = le();
    return ce(g, R).then(() => {
      const r = b.current;
      if (!r) return;
      const l = r.querySelectorAll(
        ".vc-video-container"
      ), a = [];
      l.forEach((t) => {
        const s = t.querySelector(".video-js");
        if (s)
          try {
            if (o && window.bc)
              try {
                window.bc(s);
              } catch {
              }
            a.push(
              new Promise(
                (n) => window.videojs(s).ready(function() {
                  n([this, t, s]);
                })
              )
            );
          } catch {
            c("error"), w("Video unavailable"), d(!0), f(!1);
          }
      }), Promise.all(a).then((t) => {
        t.forEach(([s, n, i]) => {
          const L = n;
          L.videoEl = i, L.player = s, h.current = s, s.ready(function() {
            try {
              const u = this.play();
              u && typeof u.catch == "function" && u.catch(() => {
                d(!1), f(!1), c("paused");
              });
            } catch {
              d(!1), f(!1), c("paused");
            }
          }), s.on("play", () => {
            v == null || v.notifyPlay(T.current), d(!1), f(!1), c("playing"), te(s, n, i);
          }), s.on("playing", () => {
            d(!1), f(!1), c("playing");
            const u = n.querySelector(
              ".vjs-control-bar button"
            );
            u == null || u.focus();
          }), s.on(
            "ended",
            () => se(s, n, i)
          ), s.on(
            "pause",
            () => ee(s, n)
          ), s.on("error", () => {
            c("error"), w("Video unavailable"), d(!0), f(!1);
          }), s.on("loadedmetadata", () => A == null ? void 0 : A());
        });
      });
    }).catch(() => {
      c("error"), w("Failed to load video player"), d(!0), f(!1);
    }), () => {
      const r = h.current;
      if (r) {
        try {
          r.dispose();
        } catch {
        }
        h.current = null;
      }
    };
  }, [S, _]), E(() => {
    const e = I.current;
    if (e) {
      const o = e.closest(".Promo-video, .Promo-video-content"), r = e.closest(".Promo-redesign");
      o && !r && M(!0);
    }
  }, []), E(() => {
    if (!v) return;
    const e = T.current, o = () => {
      const r = h.current;
      r && (r.pause(), c("paused"));
    };
    return v.register(e, o), () => {
      v.unregister(e);
    };
  }, [v]);
  const ee = k(
    (e, o) => {
      o.classList.remove("currently-playing"), o.classList.add("currently-paused"), e.pause(), c("paused"), window.matchMedia("(max-width: 768px)").matches && o.classList.contains("inline") && e.bigPlayButton.el_.style.setProperty("display", "block");
    },
    []
  ), se = k(
    (e, o, r) => {
      e.autoplay(!1), o.classList.remove("currently-playing"), o.classList.remove("currently-paused"), c("ended"), e.isFullscreen() && e.exitFullscreen(), e.isInline && (o.classList.add("inline"), r.classList.add("inline")), e.posterImage.el_.style.setProperty("display", "block"), e.bigPlayButton.el_.style.setProperty("display", "block"), e.loadingSpinner.el_.style.setProperty("display", "none"), e.currentTime(0), e.pause(), d(!0), f(!1);
    },
    []
  ), te = k(
    (e, o, r) => {
      const l = b.current;
      l && (l.querySelectorAll(
        ".vjs-quality-menu-wrapper"
      ).forEach((t) => {
        t.classList.contains("vjs-hidden") && (t.classList.remove("vjs-hidden"), t.classList.add("vjs-menu-popup-qualityLevel"));
      }), l.querySelectorAll(".currently-playing").forEach((t) => {
        t.classList.remove("currently-playing");
        const s = t;
        s.player && (s.player.pause(), s.player.bigPlayButton.el_.style.setProperty("display", "block"), s.player.posterImage.el_.style.setProperty("display", "block"));
      })), e.posterImage.el_.style.setProperty("display", "none"), e.bigPlayButton.el_.style.setProperty("display", "none"), r.classList.contains("inline") && (e.isInline = !0, r.classList.remove("inline"), o.classList.remove("inline")), o.classList.add("currently-playing"), o.classList.remove("currently-paused"), c("playing"), re(e.id_, e);
    },
    []
  );
  function re(e, o) {
    var L;
    o.loadingSpinner.el_.style.setProperty("display", "");
    const r = (L = b.current) == null ? void 0 : L.querySelector(`#${e}`);
    if (!r) return;
    const l = r.querySelector(".vjs-control-bar");
    if (!l) return;
    const a = Array.from(l.children), t = a.find(
      (u) => {
        var P;
        return (P = u.textContent) == null ? void 0 : P.includes("Playback Rate");
      }
    ), s = a.find(
      (u) => {
        var P;
        return (P = u.textContent) == null ? void 0 : P.includes("Quality Levels");
      }
    ), n = (t == null ? void 0 : t.querySelector(".vjs-menu")) ?? null, i = (s == null ? void 0 : s.querySelector(".vjs-menu")) ?? null;
    l.addEventListener("mouseenter", () => {
      n == null || n.classList.remove("vjs-menu-popup-playback"), i == null || i.classList.remove("vjs-menu-popup-quality");
    }), t == null || t.addEventListener("mouseenter", () => {
      n == null || n.classList.add("vjs-menu-popup-playback"), i == null || i.classList.remove(
        "vjs-menu-popup-quality",
        "vjs-lock-showing"
      );
    }), s == null || s.addEventListener("mouseenter", () => {
      n == null || n.classList.remove("vjs-menu-popup-playback"), i == null || i.classList.add("vjs-menu-popup-quality"), i == null || i.classList.remove("vjs-lock-showing");
    }), s == null || s.addEventListener("click", () => {
      i == null || i.classList.remove("vjs-lock-showing");
    }), n == null || n.addEventListener("mouseleave", () => {
      n.classList.remove("vjs-menu-popup-playback");
    }), i == null || i.addEventListener("mouseleave", () => {
      i.classList.remove("vjs-menu-popup-quality");
    });
  }
  const ne = () => {
    if (!N) {
      if (h.current) {
        d(!1), f(!1);
        const e = h.current.play();
        e && typeof e == "object" && "catch" in e && e.catch(() => {
          c("paused"), d(!0);
        });
        return;
      }
      f(!0), c("loading"), J(!0);
    }
  };
  return K && S.length === 0 ? null : /* @__PURE__ */ z(
    "div",
    {
      className: `video-player ${G ?? ""}${Q ? " Promo-video-layout" : ""}`,
      ref: I,
      "data-testid": Y,
      children: [
        /* @__PURE__ */ m("div", { ref: b, children: S.map((e) => /* @__PURE__ */ m(
          "div",
          {
            id: `${e.uniquePlayerId}-vc-video-container`,
            className: `vc-video-container${q ? " inline" : ""}`,
            children: /* @__PURE__ */ z("div", { className: "sixteen-by-nine-container", children: [
              _ && /* @__PURE__ */ m("div", { children: /* @__PURE__ */ m(
                "video",
                {
                  className: `video-js${q ? " inline" : ""}`,
                  controls: !0,
                  "data-video-id": e.id,
                  "data-account": g,
                  "data-player": R,
                  "data-embed": "default",
                  "data-application-id": "",
                  "data-analytics": "video",
                  "data-analytics-video-id": e.id,
                  "data-analytics-playlist-id": j,
                  id: e.uniquePlayerId,
                  children: /* @__PURE__ */ m("track", { kind: "captions" })
                }
              ) }),
              /* @__PURE__ */ m(
                de,
                {
                  posterUrl: e.poster,
                  isLoading: N,
                  isVisible: Z,
                  onActivate: ne,
                  instanceLabel: e.uniquePlayerId,
                  errorMessage: X === "error" ? B ?? void 0 : void 0
                }
              )
            ] })
          },
          e.uniquePlayerId
        )) }),
        Q && /* @__PURE__ */ m(
          ue,
          {
            accountId: g,
            policyKey: V,
            playlistId: j
          }
        )
      ]
    }
  );
};
export {
  Se as VideoPlayerDefault
};
//# sourceMappingURL=VideoPlayerDefault.mjs.map
